"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("./LayoutComponents");
var StyleConstants_1 = require("./StyleConstants");
var StyleFunctions_1 = require("./StyleFunctions");
var Typography = widgets_1.TabStyles.Typography;
var Spacing = widgets_1.TabStyles.Spacing;
var Sizing = widgets_1.TabStyles.Sizing;
exports.DataQualityStatusChipButtonStyle = {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    color: StyleConstants_1.DataQualityStatusTitleColor,
    height: Sizing.RowHeight,
    fontSize: Typography.Sizing.Default,
    paddingLeft: Spacing.DefaultSpace,
    backgroundColor: StyleConstants_1.DataQualityStatusChipBackground,
};
exports.DataQualityStatusIconButtonStyle = {
    padding: Spacing.SmallSpace,
    cursor: 'pointer',
};
exports.DataQualityDetailPanelDialogStyle = {
    width: StyleConstants_1.DataQualityDetailPanelWidth,
    maxHeight: StyleConstants_1.DataQualityDetailPanelMaxHeight,
};
exports.DataQualityDetailPanelDialogBodyStyle = {
    paddingTop: Spacing.LargeSpace,
    paddingBottom: 0,
    // Set the maximum height of both the dialog and its body for IE11 compatibility.
    maxHeight: StyleConstants_1.DataQualityDetailPanelMaxHeight,
};
exports.DataQualityDetailGroupHeadingDiv = LayoutComponents_1.divWithStyle('DataQualityDetailGroupHeadingDiv', {
    fontWeight: 'bold',
    marginBottom: Spacing.LargeSpace,
});
exports.DataQualityDetailGroupDiv = LayoutComponents_1.divWithStyle('DataQualityDetailGroupDiv', {
    fontSize: Typography.Sizing.Default,
    paddingLeft: 9,
    width: 255,
});
exports.DataQualityDetailGroupSpacerDiv = LayoutComponents_1.divWithStyle('DataQualityDetailGroupSpacerDiv', {
    height: 9
});
exports.DataQualityDetailStyle = LayoutComponents_1.divWithStyle('DataQualityDetailDiv', {
    marginBottom: Spacing.LargeSpace,
});
exports.DataQualityTooltipLabelClass = StyleFunctions_1.cssClass('DataQualityTooltipLabelClass', {
    color: StyleConstants_1.DataQualityStatusTitleColor,
    paddingLeft: Spacing.DefaultSpace,
    paddingRight: Spacing.DefaultSpace,
});
exports.DataQualityStatusChipIconOnlyClass = StyleFunctions_1.cssClass('DataQualityStatusChipIconOnlyClass', {
    verticalAlign: 'text-bottom',
    alignContent: 'left'
});
exports.DataQualityStatusChipIconClass = StyleFunctions_1.cssClass('DataQualityStatusChipIconClass', {
    verticalAlign: 'text-bottom'
});
exports.DataQualityDetailStatusChipStyle = LayoutComponents_1.divWithStyle('DataQualityDetailStatusChip', {
    marginBottom: Spacing.MediumSpace
});
exports.DataQualityDetailAssetStyle = LayoutComponents_1.divWithStyle('DataQualityDetailAsset', {
    fontWeight: 'bold',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    display: 'flex',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden'
});
exports.DataQualityDetailAuthorStyle = LayoutComponents_1.divWithStyle('DataQualityDetailAuthor', {
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});
exports.DataQualityDetailDateStyle = LayoutComponents_1.divWithStyle('DataQualityDetailDate', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    marginBottom: Spacing.DefaultSpace
});
exports.DataQualityDetailMessageStyle = LayoutComponents_1.divWithStyle('DataQualityDetailMessage', {
    width: 255,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
});
exports.DataQualityDetailPermissionRequired = {
    color: 'rgba(0,0,0,0.56)',
};
//# sourceMappingURL=DataQualityStyles.js.map